import Sidebar from "./Sidebar";
import { Outlet, Navigate } from "react-router-dom";

export default function AdminLayout() {
  const isAdmin = localStorage.getItem("userRole") === "admin";

  if (!isAdmin) return <Navigate to="/" replace />;

  return (
    <div className="fixed inset-0 flex bg-slate-900 text-slate-100 font-sans z-50 overflow-hidden selection:bg-indigo-500 selection:text-white">
      <Sidebar />
      <main className="flex-1 relative w-full h-full overflow-y-auto">
        {/* Arka plana çok hafif bir ışık efekti (Gradient) ekleyerek derinlik katalım */}
        <div className="absolute top-0 left-0 w-full h-96 bg-gradient-to-b from-slate-800/50 to-transparent -z-10 pointer-events-none" />
        
        <div className="p-6 md:p-10 max-w-10xl mx-auto min-h-full pb-20">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
